<button
  [ngbPopover]="userRoleExpandedPopContent"
  placement="bottom"
  triggers="manual"
  #p2="ngbPopover"
  autoClose="outside"
  (click)="toggleWithRole(p2)"
  class="ctrl link link--dotted-blue-dark"
>
  {{ role.group.name }}
</button>

<ng-template #userRoleExpandedPopContent>
  <div>
    <div class="pos-r padding-8" *ngIf="userRoleExpandedLoading">
      <app-loader [size]="'small'" [position]="'reset'"></app-loader>
    </div>
    <div *ngIf="backendError && !userRoleExpandedLoading">
      <span class="color-red-dark">{{ backendError }}</span>
    </div>
    <div *ngIf="!backendError && !userRoleExpandedLoading" class="user-role-expanded">
      <div class="title title--s">Участки сотрудника</div>
      <div class="mt-16" *ngIf="userRoleExpanded.regions">
        <div class="grid">
          <div class="grid__box grid__box--size-3">Регион</div>
          <div class="grid__box grid__box--size-9">
            <span *ngFor="let region of userRoleExpanded.regions; let last = last">
              {{ region }}
              <span *ngIf="!last">, </span>
            </span>
          </div>
        </div>
      </div>
      <div class="mt-16" *ngIf="userRoleExpanded.branches">
        <div class="grid">
          <div class="grid__box grid__box--size-3">Филиал</div>
          <div class="grid__box grid__box--size-9">
            <span *ngFor="let branch of userRoleExpanded.branches; let last = last">
              {{ branch }}
              <span *ngIf="!last">, </span>
            </span>
          </div>
        </div>
      </div>
      <div class="mt-16" *ngIf="userRoleExpanded.sectors">
        <div class="grid">
          <div class="grid__box grid__box--size-3">Участок</div>
          <div class="grid__box grid__box--size-9">
            <span *ngFor="let sector of userRoleExpanded.sectors; let last = last">
              {{ sector }}
              <span *ngIf="!last">, </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
